import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import { ContactUsButton } from "@faire/help-center-self-serve/components/ContactUsButton";
import { getTopic } from "@faire/help-center-utils/lib/topics";
import { loadingStateCss, pageMaxWidthCss } from "@faire/help-center/components/Mixin";
import { SearchField } from "@faire/help-center/components/SearchField/SearchField";
import { useSectionStore } from "@faire/help-center/hooks/useSectionStore";
import { NAVIGATION_FROM } from "@faire/help-center/views/eventEnum";
import home from "@faire/web-api/routes/support";
import { useStrictLocalization } from "@faire/web/common/localization";
import { FaireLogo } from "@faire/web/slate/icons/FaireLogo";
import { Close } from "@faire/web/slate/icons/foundation/Close";
import { Search } from "@faire/web/slate/icons/foundation/Search";
import { Column, HorizontalLine, Row } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useState } from "@faire/web/ui/hooks/useState";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { BrandRetailerMutualLink } from "./BrandRetailerMutualLink";
import { HeaderBreadcrumbs } from "./HeaderBreadcrumbs";
import { usePath } from "./hooks/usePath";
export var Header = function Header(_ref) {
  var showSearch = _ref.showSearch,
    source = _ref.source;
  var _useParams = useParams(),
    topicId = _useParams.topicId;
  var _useViewport = useViewport(),
    isTabletAndAbove = _useViewport.isTabletAndAbove;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useSectionStore = useSectionStore(),
    sections = _useSectionStore.sections;
  var _usePath = usePath(),
    isBasePath = _usePath.isBasePath,
    isBrandBasePath = _usePath.isBrandPath,
    getBreadcrumbPaths = _usePath.getBreadcrumbPaths,
    getCategoryId = _usePath.getCategoryId,
    isLoading = _usePath.isLoading;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var toggleMenu = function toggleMenu() {
    setShowMenu(!showMenu);
  };
  var topic = topicId ? getTopic(isLoading, sections, Number(topicId)) : undefined;
  var topicsCtx = {
    topic: topic,
    topicsLoading: isLoading
  };
  var categoryId = getCategoryId(topicsCtx);
  var breadcrumbPaths = getBreadcrumbPaths(topicsCtx, strictLocalize);
  var isBrandPath = isBrandBasePath(topicsCtx);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderWrapper, null, /*#__PURE__*/React.createElement(Row, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Link, {
    to: home()
  }, /*#__PURE__*/React.createElement(FaireLogo, null)), /*#__PURE__*/React.createElement(Spacer, {
    width: "5x"
  }), showSearch ? ( /*#__PURE__*/React.createElement(React.Fragment, null, isTabletAndAbove ? ( /*#__PURE__*/React.createElement(SearchField, {
    categoryId: categoryId,
    mini: true,
    miniInputSize: 360,
    isLoading: isLoading
  })) : ( /*#__PURE__*/React.createElement(Column, {
    onClick: toggleMenu
  }, showMenu ? /*#__PURE__*/React.createElement(Close, null) : /*#__PURE__*/React.createElement(Search, null))))) : null), /*#__PURE__*/React.createElement(ContactUsButton, {
    source: source,
    variant: "secondary"
  })), showMenu ? ( /*#__PURE__*/React.createElement(SearchField, {
    categoryId: categoryId,
    isLoading: isLoading,
    autoFocus: true,
    navigatedFrom: NAVIGATION_FROM.SEARCH_PAGE
  })) : ( /*#__PURE__*/React.createElement(HorizontalLine, null)), !isBasePath ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    "$isLoading": isLoading
  }, /*#__PURE__*/React.createElement(HeaderBreadcrumbs, {
    breadcrumbPaths: breadcrumbPaths
  }), /*#__PURE__*/React.createElement(BrandRetailerMutualLink, {
    isBrandPath: isBrandPath
  })), /*#__PURE__*/React.createElement(HorizontalLine, null))) : null);
};
var HeaderWrapper = styled.section.withConfig({
  displayName: "Header__HeaderWrapper"
})(["position:relative;height:60px;display:flex;justify-content:space-between;align-items:center;padding:", ";", " ", " section{margin:0;}"], getSpacing(0, "2x"), pageMaxWidthCss, loadingStateCss);
var SubHeader = styled.div.withConfig({
  displayName: "Header__SubHeader"
})(["display:flex;align-items:center;height:43px;padding:", ";& > :not(:first-child){display:none;}", "{padding:", ";& > :not(:first-child){display:initial;}}", "{padding:", ";& > :not(:first-child){display:initial;}}", " ", ""], getSpacing(0, "3x"), responsiveMediaQueries.tabletAndAbove, getSpacing(0, "5x"), responsiveMediaQueries.desktopAndAbove, getSpacing(0, "7x"), pageMaxWidthCss, loadingStateCss);